import SkillLevelInfoModal from './SkillLevelInfoModal';

export default SkillLevelInfoModal;
